.nav-search-container {
  position: relative;
  display: flex;
  align-items: center;
  height: 44px;
  flex: 0 1 auto;
  order: 0;
}

.nav-search-wrapper {
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
  max-width: 280px;
  height: 36px;
  padding: 0 12px;
  border: 1px solid rgba(255, 255, 255, 0.3);
  border-radius: 999px;
  background-color: rgba(255, 255, 255, 0.08);
  transition: all 0.2s ease;

  &:hover {
    background-color: rgba(255, 255, 255, 0.12);
    border-color: rgba(255, 255, 255, 0.5);
  }

  &:focus-within {
    background-color: rgba(255, 255, 255, 0.95);
    border-color: rgba(255, 255, 255, 1);
  }
}

.nav-search-icon {
  width: 16px;
  height: 16px;
  color: rgba(255, 255, 255, 0.6);
  flex-shrink: 0;
  margin-right: 8px;
  pointer-events: none;
  transition: color 0.2s ease;
}

.nav-search-wrapper:focus-within .nav-search-icon {
  color: rgba(22, 0, 4, 0.6);
}

.nav-search-input {
  flex: 1;
  min-width: 0;
  height: 100%;
  border: none;
  background: transparent;
  color: rgba(22, 0, 4, 1);
  font-size: 14px;
  font-family:
    Red Rose-Regular,
    sans-serif;
  font-weight: 400;
  outline: none;

  &::placeholder {
    color: rgba(255, 255, 255, 0.6);
    font-family:
      Red Rose-Regular,
      sans-serif;
  }

  .nav-search-wrapper:focus-within & {
    &::placeholder {
      color: rgba(124, 124, 124, 0.5);
    }
  }

  &:focus {
    outline: none;
  }
}

.nav-search-dropdown {
  position: absolute;
  top: calc(100% + 6px);
  left: 0;
  right: 0;
  background-color: rgba(255, 255, 255, 1);
  border: 1px solid rgba(22, 0, 4, 0.1);
  border-radius: 8px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
  max-height: 240px;
  overflow-y: auto;
  z-index: 100;
  animation: slideDown 0.2s ease;

  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background: rgba(22, 0, 4, 0.2);
    border-radius: 3px;

    &:hover {
      background: rgba(22, 0, 4, 0.3);
    }
  }
}

.nav-search-item {
  width: 100%;
  padding: 10px 12px;
  border: none;
  background: transparent;
  color: inherit;
  font-family: inherit;
  text-align: left;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  gap: 2px;
  transition: background-color 0.15s ease;
  text-decoration: none;

  &:hover,
  &.selected {
    background-color: rgba(22, 0, 4, 0.04);
  }

  &:not(:last-child) {
    border-bottom: 1px solid rgba(22, 0, 4, 0.06);
  }
}

.nav-result-name {
  font-size: 13px;
  font-family:
    Red Rose-Medium,
    sans-serif;
  font-weight: 500;
  color: rgba(22, 0, 4, 1);
  line-height: 1.3;
}

.nav-result-collection {
  font-size: 11px;
  font-family:
    Red Rose-Regular,
    sans-serif;
  font-weight: 400;
  color: rgba(124, 124, 124, 0.7);
  line-height: 1.2;
}

@keyframes slideDown {
  from {
    opacity: 0;
    transform: translateY(-6px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

// Light variant (when navigation is on white background)
// `.site-topnav--light` is a plain global class from SiteTopNav/index.scss,
// not a local token of this CSS module — must stay wrapped in `:global(...)`
// or these selectors silently never match the real DOM class.
:global(.site-topnav--light) .nav-search-wrapper {
  background-color: rgba(22, 0, 4, 0.04);
  border-color: rgba(22, 0, 4, 0.15);

  &:hover {
    background-color: rgba(22, 0, 4, 0.08);
    border-color: rgba(22, 0, 4, 0.25);
  }

  &:focus-within {
    background-color: rgba(255, 255, 255, 1);
    border-color: rgba(22, 0, 4, 0.2);
  }
}

:global(.site-topnav--light) .nav-search-icon {
  color: rgba(22, 0, 4, 0.5);
}

:global(.site-topnav--light) .nav-search-wrapper:focus-within .nav-search-icon {
  color: rgba(22, 0, 4, 0.7);
}

:global(.site-topnav--light) .nav-search-input {
  &::placeholder {
    color: rgba(22, 0, 4, 0.4);
  }

  .nav-search-wrapper:focus-within & {
    &::placeholder {
      color: rgba(124, 124, 124, 0.5);
    }
  }
}

@media (max-width: 1023px) {
  :global(.site-topnav__links) .nav-search-container {
    display: none;
  }
}

:global(.site-topnav__bar-search) {
  .nav-search-container {
    display: flex;
    width: 100%;
    height: 40px;
  }

  .nav-search-wrapper {
    width: 100%;
    max-width: none;
    height: 36px;
    padding: 0 10px;
  }

  .nav-search-input {
    font-size: 13px;
  }

  .nav-search-dropdown {
    left: 0;
    right: 0;
    z-index: 5000;
  }
}
